import { Scale, Split } from "lucide-react";
import InfoContentSection from "@cle/components/InfoContentSection";
import ReportRulesInfoContent, {
  type ReportRuleCategory,
} from "@cle/components/ReportRulesInfoContent";
import { INJUNCTION_CATEGORY_CONFIG } from "@cle/utils/calculateInjunctionCategorySummaries";

/**
 * Afgørelsesflowet har sine egne kategorier: INJUNCTION_CATEGORY_CONFIG har ikke
 * dispensation, som efteruddannelsesperioden har. Derfor udledes listen her og
 * ikke i den fælles komponent — teksten skal vise de lofter, netop dette flow
 * regner med.
 */
const AFGORELSE_RULE_CATEGORIES: ReportRuleCategory[] =
  INJUNCTION_CATEGORY_CONFIG.map((category) => ({
    label: category.label,
    maxReported: category.maxReported,
    canTransferLessons: category.canTransferLessons,
  }));

const AfgorelseInfoContent = () => {
  return (
    <div className="d-flex flex-column gap-3">
      <InfoContentSection icon={Scale} title="Påbud og pålæg">
        Afgørelsen er enten et påbud eller et pålæg.
        {/* TODO(sekretariatet): tilføj én sætning om hver — forskellen mellem
            påbud og pålæg i medlemsvendte ord. Samme tekst bør bruges her og i
            hjælpeteksten på oversigten over afgørelser. */}
      </InfoContentSection>

      <InfoContentSection icon={Split} title="Afgørelsen indberettes for sig">
        Dokumentationen her indberettes på afgørelsen og er en anden handling
        end den almindelige indberetning for en efteruddannelsesperiode.
        {/* TODO(sekretariatet): tæller lektioner indberettet på en afgørelse
            også med i den almindelige efteruddannelsesperiode? */}
      </InfoContentSection>

      <ReportRulesInfoContent categories={AFGORELSE_RULE_CATEGORIES} />
    </div>
  );
};

export default AfgorelseInfoContent;
